module.exports = __webpack_public_path__ + "static/media/About us.70552d62.png";